<template>
  <div class="vehicle">
    <div class="image">
      <img
        :src="src"
        :alt="alt"
      >
    </div>
    <span class="name">
      {{ alt }} <br>
      <slot />
    </span>
    <rating-star
      v-if="rating >= 0"
      :rating="rating"
    />
  </div>
</template>

<script>
import RatingStar from './RatingStar';

export default {
  name: 'VehicleImage',
  components: {
    RatingStar,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    rating: {
      type: Number,
      required: false,
      default: -1,
    },
  },
};
</script>

<style lang="scss" scoped>

  .vehicle {
    width: 92.6px;
    // height: 92.6px;
    text-align: center;
    @media screen and (min-width: $tablet-width) {
      width: 102.6px;
    }
  }

  .name {
    font-size: 12px;
    line-height: 1.45;
    color: #b6b6b6;
    margin-top: 6px;
    display: inline-block;
  }

  .image {
    width: 100%;
    height: 92.6px;
    position: relative;
    border: solid 6px #e6e6e6;
    border-radius: 50%;
    overflow: hidden;
    background-color: #fff;
    display: inline-block;
    box-sizing: border-box;
    @media screen and (min-width: $tablet-width) {
      height: 102.6px;
    }

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
    }
  }
</style>
